var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasData)?_c('div',{staticClass:"avatar-cell"},[_c('ProfileAvatar',{class:[
            'avatar-cell__avatar',
            { 'avatar-cell__avatar--deleted': _vm.data.deleted }
        ],attrs:{"image":_vm.data.avatarUrl,"size":"xs"}}),_c('div',[(_vm.data.name)?_c('p',{staticClass:"avatar-cell__name"},[_vm._v(" "+_vm._s(_vm.data.name)+" "),(_vm.data.deleted)?_c('span',{staticClass:"avatar-cell__name--deleted"},[_vm._v(" (Deactivated) ")]):_vm._e()]):_vm._e(),(_vm.data.title)?_c('p',{staticClass:"avatar-cell__title"},[_vm._v(_vm._s(_vm.data.title))]):_vm._e()])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }